import { forwardRef } from 'react';

import { noop } from '@perpay-web/utils/noop';

import { TextFieldV2 } from './TextFieldV2';

const FormikTextFieldV2 = forwardRef(
    (
        {
            field: { name, value, onChange: formikOnChange, ...fieldRest },
            form: { touched, errors } = { touched: {}, errors: {} },
            type = 'text',
            className,
            label,
            disabled = false,
            onChange = noop,
            onBlur = noop,
            ...rest
        },
        ref,
    ) => {
        const combinedOnChange = (e) => {
            formikOnChange(e);
            onChange(e);
        };

        return (
            <TextFieldV2
                ref={ref}
                className={className}
                name={name}
                value={value}
                label={label}
                type={type}
                disabled={disabled}
                errors={errors[name]}
                touched={touched[name]}
                onChange={combinedOnChange}
                {...rest}
                {...fieldRest}
                onBlur={onBlur}
            />
        );
    },
);

FormikTextFieldV2.displayName = 'FormikTextFieldV2';

export default FormikTextFieldV2;
